export default "__VITE_ASSET__vwRRgt3N__"